import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IIssueTypeInterface } from "@common/interfaces/issueTypeInterface"
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";

export interface IssueTypeInterfaceState extends EntityState<IIssueTypeInterface, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.ISSUE_TYPE_INTERFACES , realtimeEntity: 'IssueTypeInterface'})
export class IssueTypeInterfaceStore extends EntityStore<IssueTypeInterfaceState> {
  constructor() {
    super([]);
  }
}
